<div class="card">
  <div class="card-header">
    <h1>Reporte Venta de Proveedor por Mes</h1>
  </div>
  <div class="card-body">
    <div class="row align-items-end">
        <div class="col-md-3">
            <div class="form-check mb-3">
            <input 
              type="checkbox" 
              class="form-check-input" 
              id="withIva" 
              [(ngModel)]="withIva"
              style="transform: scale(1.5); margin-right: 8px;">
            <label class="form-check-label" for="withIva">Con IVA</label>
            </div>
        </div>

        <div class="col-md-5">
            <app-input-autocomplete-selection 
            [inputs]="inputs.product" 
            [placeholder]="'Ingresa id o nombre de un producto'"
            [filterElements]="filterProducts" 
            [typeElements]="'product'"
            [enableSelect]="true" 
            (inputMethod)="handleInput($event.event, 'product')"
            (changeMethod)="verifiedInput($event.event, 'product')"
            (changeStatus)="changeStatusInput($event.filterElement, '', 1, 'product')"
            (getTitle)="
                $event.filterElement.title = 
                (($event.filterElement.code) ? $event.filterElement.code + ' - ' : '') + 
                $event.filterElement.name
            ">
            </app-input-autocomplete-selection>

        </div>

        <div class="col-md-4">
            <button class="btn btn-primary w-100" (click)="executeSearch()">
            🔍 Buscar Dinámicamente
            </button>
        </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="table-responsive mt-3">
          <table class="table table-bordered" style="margin-bottom: 0;">
            <thead>
              <!-- Fila 1: Meses y Totales -->
              <tr class="tr-middle text-center">
                <th rowspan="2">Proveedor</th>
                <th rowspan="2">Bodega</th>
                <th rowspan="2">Producto</th>
                <th *ngFor="let month of months" colspan="2">{{month}}</th>
                <th rowspan="2">
                  Total Venta
                  <i
                    class="fa"
                    (click)="sortByColumn('totalVenta'); $event.stopPropagation()"
                    [ngClass]="{
                      'fa-arrow-right-arrow-left': sortColumn !== 'totalVenta',
                      'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'totalVenta',
                      'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'totalVenta'
                    }"
                  ></i>
                </th>
                <th rowspan="2">
                  Total Utilidad
                  <i
                    class="fa"
                    (click)="sortByColumn('totalUtilidad'); $event.stopPropagation()"
                    [ngClass]="{
                      'fa-arrow-right-arrow-left': sortColumn !== 'totalUtilidad',
                      'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'totalUtilidad',
                      'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'totalUtilidad'
                    }"
                  ></i>
                </th>
              </tr>
              <!-- Fila 2: Venta y Utilidad -->
              <tr class="tr-middle text-center">
                <ng-container *ngFor="let month of months">
                  <th>
                    Venta
                    <i 
                      class="fa" 
                      (click)="sortByColumn(month + '-venta')" 
                      [ngClass]="{
                        'fa-arrow-right-arrow-left': sortColumn !== month + '-venta',
                        'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === month + '-venta',
                        'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === month + '-venta'
                      }">
                    </i>
                  </th>
                  <th>
                    Utilidad
                    <i 
                      class="fa" 
                      (click)="sortByColumn(month + '-utilidad')" 
                      [ngClass]="{
                        'fa-arrow-right-arrow-left': sortColumn !== month + '-utilidad',
                        'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === month + '-utilidad',
                        'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === month + '-utilidad'
                      }">
                    </i>
                  </th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
            <!-- Proveedor -->
            <ng-container *ngFor="let provider of paginationProviders.filter">
                <tr class="fw-bold item tr-middle" (click)="toggleProvider(provider)">
                <td >
                    <i [ngClass]="provider.expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                    {{provider.name}}
                </td>
                <td>{{provider.provider}}</td>
                <td></td>
                <ng-container *ngFor="let month of months">
                    <td>{{ provider.monthlySales[month]?.venta | currency:'Q.':'symbol':'1.2-2' }}</td>
                    <td>{{provider.monthlySales[month]?.utilidad | currency:'Q.':'symbol':'1.2-2'}}</td>
                </ng-container>
                <td>{{provider.totalVenta | currency:'Q.':'symbol':'1.2-2'}}</td>
                <td>{{provider.totalUtilidad | currency:'Q.':'symbol':'1.2-2'}}</td>
                </tr>

                <!-- Warehouses -->
                <ng-container *ngIf="provider.expanded">
                <ng-container *ngFor="let warehouse of provider.warehouses">
                    <tr class="fw-bold item tr-middle" (click)="toggleWarehouse(warehouse, $event)">
                    <td></td>
                    <td>
                        <i [ngClass]="warehouse.expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                        {{warehouse.name}}
                    </td>
                    <td></td> <!-- Aquí agregamos la celda vacía -->
                    <ng-container *ngFor="let month of months">
                        <td>{{warehouse.monthlySales[month]?.venta | currency:'Q.':'symbol':'1.2-2'}}</td>
                        <td>{{warehouse.monthlySales[month]?.utilidad | currency:'Q.':'symbol':'1.2-2'}}</td>
                    </ng-container>
                    <td>{{warehouse.totalVenta | currency:'Q.':'symbol':'1.2-2'}}</td>
                    <td>{{warehouse.totalUtilidad | currency:'Q.':'symbol':'1.2-2'}}</td>
                    </tr>

                    <!-- Products within Warehouse -->
                    <ng-container *ngIf="warehouse.expanded">
                    <tr *ngFor="let subProduct of warehouse.products" class="item tr-middle">
                        <td></td>
                        <td></td>
                        <td>{{subProduct.name}}</td>
                        <ng-container *ngFor="let month of months">
                        <td>{{subProduct.monthlySales[month]?.venta | currency:'Q.':'symbol':'1.2-2'}}</td>
                        <td>{{subProduct.monthlySales[month]?.utilidad | currency:'Q.':'symbol':'1.2-2'}}</td>
                        </ng-container>
                        <td>{{subProduct.totalVenta | currency:'Q.':'symbol':'1.2-2'}}</td>
                        <td>{{subProduct.totalUtilidad | currency:'Q.':'symbol':'1.2-2'}}</td>
                    </tr>
                    </ng-container>
                </ng-container>
                </ng-container>
            </ng-container>
            </tbody>
            <tfoot>
              <tr class="table-secondary fw-bold text-center">
                <td colspan="3">Totales</td>
                <ng-container *ngFor="let month of months">
                  <td>{{ getTotalVenta(month) | currency:'Q.':'symbol':'1.2-2' }}</td>
                  <td>{{ getTotalUtilidad(month) | currency:'Q.':'symbol':'1.2-2' }}</td>
                </ng-container>
                <td>{{ getGranTotalVenta() | currency:'Q.':'symbol':'1.2-2' }}</td>
                <td>{{ getGranTotalUtilidad() | currency:'Q.':'symbol':'1.2-2' }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <app-pagination-custom (changed)="executeSearch()" [elements]="paginationProviders"></app-pagination-custom>
      </div>
    </div>
  </div>
</div>
